import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BruteForceWinConfigs} from "../BruteForceWinConfigs";

export class BruteForceTotalWinPresentation implements SimplePresentation {
    name: string = "TotalWinPresentation";
    private _totalWinTl: gsap.core.Timeline;

    shouldRun(): boolean {

        return BruteForce.model.gameData.betLineWins.length > 0 && !BruteForce.model.gameData.brokeTheBank && !BruteForce.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._totalWinTl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });
        BruteForce.betlineView.hideLinesAndAmount();
        const isWinBelowStake: boolean = BelowStakeWinRestriction.isWinBelowStake();
        this._totalWinTl.add(() => controller.setSkipCallback(() => {
            this._totalWinTl.timeScale(3);
        }));

        if (!isWinBelowStake) {
            this._totalWinTl.add(BruteForce.totalWinView.show(BruteForceWinConfigs.getWinRatioConfig()));
            this._totalWinTl.add(BruteForce.totalWinView.hide());
        } else {
            this._totalWinTl.to(this, {duration: 0.03});
        }
        this._totalWinTl.add(() => {
            if (!BruteForce.model.brokeTheBank) {
                BruteForce.keypadPlugin.setWin(BruteForce.model.gameData.accumulatedRoundWin, true, isWinBelowStake);
            }
        })

    }
}